export default "__VITE_ASSET__LiMHlhqU__"